var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDinersClub = function SvgDinersClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    fill: "#fff",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    fillRule: "evenodd",
    d: "M18.153 23.333h3.297c5.146 0 9.246-4.138 9.407-9.251V14c-.08-5.194-4.261-9.414-9.407-9.333H17.75c-4.905.162-8.764 4.382-8.603 9.414 0 5.031 4.02 9.17 9.005 9.251m-7.398-9.332c0-4.22 3.458-7.71 7.639-7.71s7.638 3.49 7.638 7.71-3.457 7.71-7.638 7.71-7.639-3.49-7.639-7.71m8.845 5.194V8.888c2.814.73 4.583 3.57 3.86 6.411-.483 1.948-1.93 3.409-3.86 3.896m-6.19-6.493c-.724 2.84.964 5.762 3.779 6.493V8.888a5.31 5.31 0 0 0-3.78 3.814",
    clipRule: "evenodd"
  })));
};
export default SvgDinersClub;